<template>
  <div>
    <div v-for="(comment, index) in getStudentSummary.my_comments" :key="index" class="mb-4" :class="[index !== getStudentSummary.my_comments.length - 1 ? 'individual-comment' : '', comment.is_hidden ? 'hidden-record' : '',]">
      <div v-if="comment" class="flex justify-between text-xs text-gray-500">
        <div class="flex justify-between truncate-text items-end py-1 font-manrope">
          <span> {{ inResponseTo(comment) }} </span>
          <div v-if="createdAfterEnd(comment)" class="text-xs text-red-500 px-3">
            Posted after close
          </div>
        </div>
        <StarButton type="summary" class="mx-3" :comment="comment" />
      </div>
      <div class="white-spaced-text break-words py-1 font-manrope text-gray-900">
        {{ comment.content }}
      </div>
      <div v-if="$route.name === 'roundtable.discussion'">
        <button @click="goToCommentContext(comment)" class="text-primary hover:text-primary-dark cursor-pointer font-manrope">
          See Context
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';
  import { EventBus } from '../../utils/event-bus';
  export default Vue.extend({
    data: () => ({
      is_show_more_content: false,
    }),
    components: {
      StarButton: () =>
        import('features/onlineRoundtables/components/starButton/starButton'),
    },
    computed: {
      ...mapGetters(['getStudentSummary', 'getCurrentRT', 'getProfile']),
    },
    methods: {
      handleHideText: function (string, max_length) {
        if (string.length <= max_length) {
          return string;
        }

        const hiddenText = '...';
        const visibleText = string.substring(0, max_length - hiddenText.length);
        return visibleText + hiddenText;
      },
      createdAfterEnd: function (comment) {
        const endedTime = this.getCurrentRT.end_date;
        if (
          endedTime &&
          comment.comment_date &&
          comment.comment_date > endedTime
        )
          return true;
        return false;
      },
      goToCommentContext: async function (comment) {
        const { submission_id, comment_id, id, recap_id } = comment;
        const route = {
          query: Object.assign({}, this.$route.query, {
            submissionID: submission_id,
            recapID: recap_id,
            replyCommentID: comment_id ? id : null,
            topLevelCommentID: comment_id || id,
          }),
        };
        if (this.$route.name !== 'roundtable.discussion') {
          this.$router.push(route);
          if (submission_id) {
            await this.$store.dispatch(
              'loadSubmissionComments',
              comment.submission_id
            );
          }
        }
        if (
          this.getProfile.my_rt_user_details.submission_id !==
          comment.submission_id
        ) {
          EventBus.$emit('seeContext', submission_id, recap_id, route.query);
        } else {
          EventBus.$emit('myContext', comment);
        }
      },
      inResponseTo: function (comment) {
        const genie =
          comment.submission_author_name === 'Genie Recap' ? true : false;
        if (comment.parent_comment_author_name)
          return `Replying to ${
            comment.parent_comment_author_name
          }'s comment in ${comment.submission_author_name}${
            genie ? '.' : `'s submission.`
          }`;
        return `In response to ${comment.submission_author_name}${
          genie ? '.' : `'s submission.`
        }`;
      },
    },
  });
</script>
<style scoped lang="stylus">
  @import '~app/global-stylus'
  .primary-colour
    color: pl-primary

  p {
    margin: 0px;
  }
  .comment-summary {
    margin-bottom: 20px;
  }
  .comment-summary-card-spacing {
    margin-bottom: 24px;
  }
  .light-grey {
    color: #86939E;
  }
  .measure-subtitle {
    padding-bottom: 8px;
  }
  .posted_after_close_style{
    color: #EB2D7C;
    font-size: 10px;
  }
</style>



// WEBPACK FOOTER //
// commentSummary.vue?c10fe4a8